<template>
<!-- 方案管理 -->
  <div class="scheme-manage">
    <div class="manage-section">
      <div class="opt-box">
        <el-button type="primary" @click="goAutoGenerate">智慧生成</el-button>
        <el-button type="primary" @click="onClickCreateScheme">新建方案</el-button>
        <el-button type="primary" @click="dialogSchemeImport=true">方案导入</el-button>
      </div>
      <el-table class="manage-table" :data="tableData" v-loading="loading" element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" :header-cell-class-name="cellClass"
                :row-class-name="getRowClassName" ref="multipleTable" @selection-change="handleSelectionChange"
                style="width: 100%;">
        <el-table-column prop="programmeId" label="编号" min-width="45px">
          <template slot-scope="scope">
            <span>{{ scope.row.num }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="programmeName" label="方案名称" min-width="120px">
          <template slot-scope="scope">
            <span>{{scope.row.programmeName}}</span>
            <span v-if="scope.row.batch.indexOf('提前') >= 0">-{{scope.row.recruitType}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="majorType" label="科类" min-width="80px">
          <template slot-scope="scope">
            <span v-if="scope.row.majorType == 1">物理</span>
            <span v-if="scope.row.majorType == 2">历史</span>
            <span v-if="scope.row.majorType == 3">物理</span>
            <span v-if="scope.row.majorType == 4">历史</span>
            <span v-if="scope.row.subject1">+{{scope.row.subject1}}</span>
            <span v-if="scope.row.subject2">+{{scope.row.subject2}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="分数" width="50px">
        </el-table-column>
        <el-table-column prop="precedence" label="位次" width="80px">
        </el-table-column>
        <el-table-column prop="batch" label="批次" min-width="80px">
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" min-width="100px">
        </el-table-column>
        <el-table-column prop="" label="生成方式" min-width="60px">
          <template slot-scope="scope">
            {{ { 1: '人工设计', 2: '智慧生成', 3:'智慧转人工' }[scope.row.schemeType] || '' }}
          </template>

        </el-table-column>
        <el-table-column prop="" label="方案标记" width="80px" align="center">
          <template slot-scope="scope">
             <el-dropdown @command="(command) => handleCommand(command, scope.row)">
              <span style="cursor: pointer;">
                <span :class="'flag-' + scope.row.flag">{{ scope.row.flag }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="模案">模案</el-dropdown-item>
                <el-dropdown-item command="预案">预案</el-dropdown-item>
                <el-dropdown-item command="正案">正案</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="210px">
          <template slot-scope="scope">
            <el-button-group>
              <el-button type="primary" plain size="small" @click="goPreview(scope.row)">预览修改</el-button>
              <el-button type="primary" plain size="small" @click="toPrint(scope.row)">下载打印</el-button>
              <el-button type="primary" plain size="small" @click="copyCode(scope.row)">方案复制</el-button>
              <el-button type="primary" plain size="small" @click="deleteProgramme(scope.$index,tableData,scope.row)">删除</el-button>
            </el-button-group>
          </template>
        </el-table-column>
        <el-table-column type="selection" width="80" align="center">
        </el-table-column>
      </el-table>
    </div>

    <!-- 右侧悬浮 -->
    <div id="npt" >
      <div style="background-color: #5DBE2D;" @click="goPrint()">
        <i class="icon-el el-icon-printer"></i>
        <span>批量<br>打印</span>
      </div>
    </div>

    <CreateScheme title="新建方案"
      ref="createScheme"
      @submitted="onSubmitted"
      :dialog-visible.sync="schemeFormDialog"
    />

    <UpdateScore title="高考成绩确认"
      @getStu="getStu"
    />

    <el-dialog title="方案导入" :visible.sync="dialogSchemeImport" :close-on-click-modal="false">
      <el-form :model="importForm" abel-width="80px">
        <el-form-item label="方案标识" >
          <el-input v-model="importForm.uniqueCode" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogSchemeImport = false">取 消</el-button>
        <el-button type="primary" @click="saveSchemeImport">确 定</el-button>
      </div>
    </el-dialog>

  </div>

</template>

<script>
import {request} from "@/util/request";
import CreateScheme from "./components/CreateScheme.vue";
import UpdateScore from "@/components/studentInitData/updateScore.vue"

export default {
  name: "index",
  components: {CreateScheme, UpdateScore},
  data () {
    return {
      loading: false,
      // 方案列表
      tableData: [],
      multiplePrint: [],
      // 新建方案弹窗
      schemeFormDialog: false,
      newSchemeForm: {
        majorType: 1,
        name: '理工本科普通批平行',
        region: '本科普通批平行',
      },
      // 用户信息
      user: null,
      infos: {},
      neweditForm: [],
      // 方案导入
      dialogSchemeImport: false,
      importForm: {
        uniqueCode: ''
      }
    }
  },
  created() {
    const user = sessionStorage.getItem("user");
    this.user = JSON.parse(user)
    this.getStu()
  },
  methods: {
    handleCommand(command, row) {
      request({
        method: 'post',
        url: 'stuSchemeV2/updateProgrammeMain',
        data: {
          id: row.id,
          flag: command,
        }
      }).then(res => {
        if (![0, 200].includes(res.code)) {
          return this.$message.error(res.msg);
        }
        this.$message.success('操作成功');
        this.getProgramme()
      })
    },
    getRowClassName({ row, rowIndex }) {
      if (rowIndex > 0 && this.tableData[rowIndex].batch !== this.tableData[rowIndex - 1].batch) {
        return 'has-top-separator';
      }
      return '';
    },

    // 获取学生数据
    getStu() {
      if (this.user != null) {
        request({
          method: 'get',
          url: 'students/getStu',
          params: {
            Id: this.user.userId
          }
        }).then(res => {
          this.infos = res.data
          localStorage.setItem('stu', JSON.stringify(this.infos))
          this.getProgramme()
        })
      }
    },
    // 获取方案列表
    getProgramme() {
      this.loading = true
      request({
        method: 'POST',
        url: 'stuSchemeV2/getProgramme',
        params: {
          stuId: this.infos.id
        }
      }).then(res => {
        this.tableData = res.data
        this.loading = false
      })
    },
    goAutoGenerate() {
      localStorage.removeItem("autoGenerateForm");
      this.$router.push('/autoGenerate')
    },
    // 复制方案
    copyCode (row) {
      this.$copyText(row.uniqueCode).then(
        () =>{
          this.$message({
            showClose: true,
            message: '复制成功！',
            type: 'success',
            duration: 1000
          });
        },
        (e) => {
          this.$message.error('复制失败')
        }
      )
    },
    saveSchemeImport () {
      if (!this.importForm.uniqueCode) {
        return this.$message.error('请输入方案标识');
      }
      request({
        method: 'post',
        url: 'stuSchemeV2/copyScheme?stuId=' + this.infos.id + '&uniqueCode=' + this.importForm.uniqueCode,
      }).then(res => {
        if (![0, 200].includes(res.code)) {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        } else {
          this.$message({
            showClose: true,
            message: '导入成功！',
            type: 'success',
            duration: 1000
          });
          this.dialogSchemeImport = false;
          this.getProgramme()
        }
      })
    },
    onClickCreateScheme() {
      var userInfo = JSON.parse(localStorage.getItem("stu"));
      this.infos.major = userInfo.major;
      this.infos.subject1 = userInfo.subject1;
      this.infos.subject2 = userInfo.subject2;
      this.$refs.createScheme.setData(this.infos)
      this.schemeFormDialog = true
    },
    // 下载打印
    toPrint(row) {
      const infos = row;
      if (infos.majorType === null) {
        infos.majorType = this.newSchemeForm.majorType;
      }
      localStorage.setItem('SingleScheme', JSON.stringify(infos))
      this.$router.push({
        name: 'singlePrint',
        params: {
          info: infos
        }
      })
    },
    // 修改多选框表头
    cellClass (row) {
      // 判断第几列
      if (row.columnIndex === 10) {
        return "disableSelection";
      }
    },
    // 多选方案
    handleSelectionChange(val) {
      this.multiplePrint = val;
    },
    // 批量打印
    goPrint() {
      if (this.multiplePrint.length === 0) {
        return this.$message.error('请选择要打印的方案');
      }
      // 整理参数，传到下个页面
      let printList = [];
      this.multiplePrint.forEach(item => {
        printList.push(item.id)
      })
      this.$router.push({
        path: '/downAndPrint?ids=' + printList
      })
    },
    // 预览修改
    goPreview (row) {
      const infos = row;
      if (infos.majorType === null) {
        infos.majorType = this.newSchemeForm.majorType;
      }
      localStorage.setItem('volunteer', JSON.stringify(infos))
      this.$router.push({
        name: 'schemePreview',
        params: {
          info: infos
        }
      })
    },
    // 删除方案
    deleteProgramme(index, rows, row) {
      this.$confirm('确定删除该方案嘛?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          method: 'get',
          url: 'stuSchemeV2/deleteProgramme',
          params: {
            programmeId: row.programmeId,
            stuId: this.infos.id,
            batch: row.batch,
          }
        }).then(res => {
          if (res.code == 0 || res.code == 200) {
            rows.splice(index, 1);
            this.$message({
              message: '删除成功！',
              type: 'success'
            });
            this.sortSchemeFn();
          } else {
            this.$message({
              message: '删除失败~',
              type: 'error'
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 排序
    sortSchemeFn () {
      request({
        method: 'post',
        url: 'stuSchemeV2/UpdateSort',
        data: {stuId: this.infos.id}
      }).then(res => {
        this.getProgramme();
      })
    },
    onSubmitted(res) {
      this.update(res.data.list)
    },
    // 保存方案成功后调用
    update(row) {
      const programe = row;
      this.$router.push({
        path: '/schemeMake',
        query: {
          examineeId: this.stuId,
          student: JSON.stringify(programe)
        }
      })
    },
  },
}
</script>
<style scoped>
/* 使用深度选择器 */
.manage-table >>> .has-top-separator td.el-table__cell {
  border-top: 2px solid #fdc2ac;
}
.manage-table >>> .disableSelection .cell .el-checkbox__inner {
  display: none;
  position: relative;
}

.manage-table >>> .disableSelection .cell::before {
  content: "打印勾选";
  position: absolute;
  left: 10px;
}

</style>
<style lang="stylus">
.scheme-manage
  .el-table th.el-table__cell
    background-color: #f0f0f0;

  .manage-table {
    /* 修改Element UI Checkbox的大小 */
    .el-checkbox .el-checkbox__input .el-checkbox__inner,
    .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      width: 20px;
      height: 20px;
      border: 1px solid #f96630;
    }

    .el-checkbox__inner::after{
      border: 1px solid #fff;
      border-left: 0;
      border-top: 0;
      left: 7px;
      top: 4px;
    }
    .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner::after {
      transform: rotate(45deg) scaleY(1.6);
    }
  }

</style>
<style lang="stylus" scoped>
pageWidth = 1400px

.flag-预案 {
  color green
}
.flag-正案 {
  color red
}
.scheme-manage
  width: pageWidth;
  min-height: BodyMinHeight;
  margin: 0 auto;
  font-size: 16px;

  .nav-section
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 20px 0;
    font-size: 18px;

    .nav-block
      flex 1
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .title
        width: 100px;

      img
        display: block;
        width: 18px;
        height: 18px;
        margin-right: 10px;

      i
        margin: 0 2px;

    .stu-info
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 166px;
      height: 40px;
      background: #FFF2E7;
      font-size: 18px;
      color: #333;

      img
        display: block;
        width: 18px;
        margin-right: 20px;

  .manage-section
    padding: 0 20px;
    margin-bottom: 40px;
    background: #fff;

    .opt-box
      padding 20px 0
      text-align right

  .right-btn-box
    position: fixed;
    top: 50%;
    right: 10px;
    margin-top: -30px;
    width: 60px;
    height: 60px;

</style>
